import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('custom-modal-layout', {
  root: {
    states: ['removeContentPadding', 'showHeaderDivider', 'showFooterDivider'],
  },
});
